module.exports = "/assets/7220e616e7fab2432551f0c19f721f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/QI.png
// module id = 1752
// module chunks = 0